@let showPoints = sourceAgainstGame().getState() === Finished;
<ng-container
    *ngTemplateOutlet="contentHome; context:{poolUserRow: poolUserRow(), gameRound: gameRound(), showPoints: showPoints}">
</ng-container>
<td class="text-center px-0" [class.table-success]="isSelectedPoolUser(poolUserRow().poolUser)">
    <a class="text-decoration-underline pointer"
      [class.fw-bold]="isSelectedPoolUser(poolUserRow().poolUser)"
      [routerLink]="getPoolUserLink(poolUserRow().poolUser)"
      (click)="selectPoolUser(poolUserRow().poolUser)">
        {{poolUserRow().poolUser.getName()}}
    </a>
</td>
<ng-container
    *ngTemplateOutlet="contentAway; context:{poolUserRow: poolUserRow(), gameRound: gameRound(), showPoints: showPoints}">
</ng-container>

<ng-template #contentHome let-poolUserRow="poolUserRow" let-gameRound="gameRound" let-showPoints="showPoints">
  @let formationPlace = poolUserRow.homeFormationPlace;
  @let s11Player = $safeNavigationMigration(formationPlace?.getPlayer());  
  <!-- sub -->
  <td class="px-0">              
    @if(formationPlace !== undefined && formationPlace.isSubstitute()) {
      @let shouldAppear = statisticsGetter().shouldSubstituteAppear(formationPlace.getFormationLine(), gameRound);
      @if( shouldAppear === undefined ) {
        <span class="badge badge-substitute-unknown">r</span>
      } @else if( shouldAppear === true ) {
        <span class="badge badge-substitute-used">r</span>
      } @else {
        <span class="badge badge-substitute-unused">r</span>
      }    
    }
  </td>

  <!-- name -->
  <td [attr.colspan]="showPoints ? 1 : 2" class="text-end px-0">
      @if(s11Player){
        <span class="px-1 text-break">{{s11Player.getPerson().getName()}}</span>
      }
  </td>

  <!-- line -->
  <td>
      @if(s11Player){
          <app-lineicon [line]="s11Player.getLine()"></app-lineicon>
      }
  </td>
  
  <!-- points -->
  @if(showPoints) {
    <td class="ps-0">
      @if(formationPlace){
        
        @if(!formationPlace.isSubstitute() || statisticsGetter().isSubstituteUsed(formationPlace,gameRound)){        
          @if(statisticsGetter().hasAppeared(formationPlace, gameRound)){          
            <ng-container
              *ngTemplateOutlet="appearedbtn; context:{formationPlace, gameRound, s11Player}">
            </ng-container>            
          }
          @else {
            <button type="button" class="btn btn-sm btn-not-appeared-2-digits">NP</button>
          }
        }
      }
    </td>
  }
</ng-template>

<ng-template #appearedbtn let-formationPlace="formationPlace" let-s11Player="s11Player" let-gameRound="gameRound">
  @let statistics = statisticsGetter().getStatistics(s11Player, gameRound.number);
  @if( statistics !== undefined ) { 
    <div class="text-end me-1">                        
      <button type="button" class="btn btn-sm btn-points-normal-2-digits mb-1" (click)="openPlayerModal(s11Player)">
        {{statisticsGetter().getFormationPlaceGameRoundPoints(formationPlace,gameRound, undefined)}}
      </button>
      <div  class="d-flex flex-column align-items-end">        
        <ngb-progressbar-stacked class="mb-1" style="height: 5px; width: 100%;">
          @for(appColumn of getAppearanceColumns(statistics); track $index){
            <ngb-progressbar type="{{appColumn.playing ? 'primary' : 'secondary'}}" [value]="appColumn.percentage" height="0.5rem"></ngb-progressbar>
          }          
        </ngb-progressbar-stacked>                
      </div>                                        
    </div>      
  }
</ng-template>

<ng-template #contentAway let-poolUserRow="poolUserRow" let-gameRound="gameRound">
  @let formationPlace = poolUserRow.awayFormationPlace;
  @let s11Player = $safeNavigationMigration(formationPlace?.getPlayer());  

  <!-- points -->
  @if(showPoints) {
    <td class="pe-0">
      @if(formationPlace){
        
        @if(!formationPlace.isSubstitute() || statisticsGetter().isSubstituteUsed(formationPlace,gameRound)){        
          @if(statisticsGetter().hasAppeared(formationPlace, gameRound)){          
            <ng-container
              *ngTemplateOutlet="appearedbtn; context:{formationPlace, gameRound, s11Player}">
            </ng-container>            
          }
          @else {
            <button type="button" class="btn btn-sm btn-not-appeared-2-digits">NP</button>
          }
        }
      }
    </td>
  }

  <!-- line -->
  <td>
      @if(s11Player){
          <app-lineicon [line]="s11Player.getLine()"></app-lineicon>
      }
  </td>

    <!-- name -->
  <td [attr.colspan]="showPoints ? 1 : 2" class="px-0">
      @if(s11Player){    
        <span class="px-1 text-break">{{s11Player.getPerson().getName()}}</span>
      }
  </td>

  <!-- sub -->
  <td class="px-0">
    @if(formationPlace !== undefined && formationPlace.isSubstitute()) {
      @let shouldAppear = statisticsGetter().shouldSubstituteAppear(formationPlace.getFormationLine(), gameRound);
      @if( shouldAppear === undefined ) {
        <span class="badge badge-substitute-unknown">r</span>
      } @else if( shouldAppear === true ) {
        <span class="badge badge-substitute-used">r</span>
      } @else {
        <span class="badge badge-substitute-unused">r</span>
      }    
    }
  </td>

</ng-template>